/**
 * Shuffles array in place.
 * @param {Array} array items The array containing the items.
 */
export function shuffle(array: any[]) {
  let j, x, i;
  for (i = array.length; i; i--) {
    j = Math.floor(Math.random() * i);
    x = array[i - 1];
    array[i - 1] = array[j];
    array[j] = x;
  }
}
